import "./TheCarolinasEdge.module.css";
import ExecutiveNavigation from "@/reusable_sections/Header";
import AVisionForTheCarolinas from "./sections/AVisionForTheCarolinas";
import OurGuidingPhilosophy from "./sections/OurGuidingPhilosophy";
import LeadershipInsights from "./sections/LeadershipInsights";
import LegacyFooter from "@/reusable_sections/Footer";
export default function TheCarolinasEdgePage() {
  return <div>
      <ExecutiveNavigation />
      <AVisionForTheCarolinas />
      <OurGuidingPhilosophy />
      <LeadershipInsights />
      <LegacyFooter />
    </div>;
}